import { FC, useState } from 'react';
import { CustomButton, CustomModal, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { useEditJobDescriptionMutation } from '../api';
import { API_RESPONSES } from 'types/baseTypes';
import { CircleCloseIcon } from 'assets/icons';

interface EditDescriptionModalProps {
  description: string;
  onClose: () => void;
  onSave: (description: string) => void;
  jobId: string;
  teamId: number;
  jobNumber: string;
}

const EditDescriptionModal: FC<EditDescriptionModalProps> = ({
  description,
  onClose,
  onSave,
  jobId,
  teamId,
  jobNumber
}) => {
  const [jobDescription, setJobDescription] = useState(description);

  const [editJobDescriptionMutation, editJobDescriptionState] = useEditJobDescriptionMutation();
  const { isLoading: isEditJobDescriptionLoading } = editJobDescriptionState;

  const onSaveClick = () => {
    editJobDescriptionMutation({
      description: jobDescription.trim(),
      jobId,
      teamId
    }).then(response => {
      if ('data' in response && response.data.data.message === API_RESPONSES.SUCCESS) {
        onSave(jobDescription.trim());
        onClose();
      }
    });
  };

  return (
    <CustomModal open={true} closeModal={onClose} width="md:w-[510px]">
      <div className="h-full px-[30px] py-6">
        <div className="relative mb-6 flex items-center">
          <div className="flex flex-col text-headingGray">
            <span className="text-17px font-bold">Edit job description</span>
            <span className="mt-1 text-sbase font-semibold">{jobNumber}</span>
          </div>
          <CircleCloseIcon className="absolute right-0 top-0 cursor-pointer" onClick={onClose} />
        </div>

        <div className="mb-6">
          <div className="mb-2 text-sbase font-semibold text-primaryText">Description</div>
          <CustomTextArea
            id="edit-Description-note"
            name="edit-Description-note"
            placeholder="Add description here"
            className="h-[140px] max-h-[140px] w-full rounded-md border border-borderGray
             bg-secondaryBtn font-semibold text-primaryText focus:outline-none"
            value={jobDescription}
            onChange={setJobDescription}
          />
        </div>

        <div className="flex w-full justify-end gap-x-4">
          <CustomButton
            id="edit-Description-cancel-button"
            className="w-[100px]"
            onClick={onClose}
            type={ButtonType.SECONDARY}>
            Cancel
          </CustomButton>
          <CustomButton
            id="edit-Description-save-button"
            className="w-[100px]"
            onClick={onSaveClick}
            isLoading={isEditJobDescriptionLoading}
            type={ButtonType.PRIMARY}
            disabled={description.trim() === jobDescription.trim()}>
            Save
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditDescriptionModal;
